import { AmbientBackground } from "@/components/landing";
import { SupportForm } from "@/components/support/SupportForm";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export function SupportPage() {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <AmbientBackground />

      <div className="w-full max-w-lg mx-auto relative z-10">
        {/* Logo */}
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex items-center gap-2">
            <img
              src="/logo.svg"
              alt="Logo"
              className="h-8 w-8"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
            <span className="text-xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
              HolyMolyLab
            </span>
          </Link>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl border-3 border-black shadow-[8px_8px_0_0_#000] p-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold font-['Sora'] tracking-tight">
              Get in Touch
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              Have a question or need help? We'd love to hear from you.
            </p>
          </div>

          <SupportForm />
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SupportPage;
